import _ from 'lodash';
import * as ActionTypes from '../actions/userActions';

export const users = (
  state = {
    currentUser: null,
    users: [],
    isLoading: false,
    isLoadingMore: false,
    isSearching: false,
    isLoadingTags: false,
    pagination: null,
    aggregates: null
  },
  action
) => {
  switch (action.type) {
    case ActionTypes.GET_USERS_REQUEST:
      const isFirstPage = !action.params?.page || action.params.page === 1;
      const isSearch = !!action.params?.search;
      const isFetchingTags = !!action.params?.withTags && isFirstPage;

      return {
        ...state,
        isLoading: isFirstPage && !isSearch,
        isLoadingMore: !isFirstPage,
        isSearching: isSearch,
        isLoadingTags: isFetchingTags
      };

    case ActionTypes.GET_USERS_SUCCESS:
      const shouldAppend = action.pagination?.page > 1;
      return {
        ...state,
        users: shouldAppend ? [...state.users, ...action.users] : action.users,
        pagination: action.pagination,
        aggregates: action.aggregates,
        isLoading: false,
        isLoadingMore: false,
        isSearching: false,
        isLoadingTags: false
      };

    case ActionTypes.CLEAR_USERS:
      return {
        ...state,
        users: [],
        isLoading: true,
        isSearching: false,
        isLoadingTags: false,
        pagination: {
          page: 1,
          limit: 100,
          total: 0,
          totalPages: 0,
          hasMore: false
        }
      };
    case ActionTypes.APPLY_TAG_TO_USERS_REQUEST:
      const userTagsBeingApplied = _.reduce(action.users, (r, u) => ({ ...r, [u.id]: true }), {}); // For performance
      return {
        ...state,
        users: state.users.map(user => {
          const isTagApplied = userTagsBeingApplied[user.id];
          return {
            ...user,
            tags: isTagApplied ? _.uniq(_.concat(user.tags, action.tag), 'id') : user.tags
          };
        })
      };

    case ActionTypes.DELETE_USER_TAG_REQUEST:
      return {
        ...state,
        users: state.users.map(user => {
          return {
            ...user,
            tags: user.id === action.user.id ? _.filter(user.tags, t => t.id !== action.tag.id) : user.tags
          };
        })
      };

    case ActionTypes.SET_CURRENT_USER:
      return {
        ...state,
        currentUser: action.currentUser
      };

    case ActionTypes.LOGOUT_USER_SUCCESS:
      return {
        ...state,
        currentUser: null,
        users: []
      };

    case ActionTypes.UPDATE_USER_IN_STATE:
      return {
        ...state,
        users: state.users.map(user => (user.id === action.userId ? { ...user, ...action.updates } : user))
      };

    case ActionTypes.UPDATE_USER_FIELD_REQUEST:
      return {
        ...state,
        users: state.users.map(user =>
          user.id === action.userId
            ? {
                ...user,
                [action.fieldName]: action.newValue,
                _updating: action.fieldName
              }
            : user
        )
      };

    case ActionTypes.UPDATE_USER_FIELD_SUCCESS:
      return {
        ...state,
        users: state.users.map(user =>
          user.id === action.userId
            ? {
                ...user,
                _updating: null,
                _updateSuccess: action.fieldName
              }
            : user
        )
      };

    case ActionTypes.UPDATE_USER_FIELD_ERROR:
      return {
        ...state,
        users: state.users.map(user =>
          user.id === action.userId
            ? {
                ...user,
                [action.fieldName]: action.oldValue,
                _updating: null,
                _updateSuccess: null
              }
            : user
        )
      };

    default:
      return state;
  }
};
